import Loader from "./loader.js";
export default function(settings) {
  return Loader.load(settings.gateway_type, "https://js.stripe.com/v3");
}
